import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  private datePipe = new DatePipe('en-US');

  /**
   * Transform date to API format (yyyy-MM-dd)
   * Used when sending dates to the API
   * Uses local date components to avoid timezone conversion
   */
  transformPOSTDate(date: Date | string | null): string | null {
    if (!date) return null;
    
    let dateObj: Date;
    if (date instanceof Date) {
      dateObj = date;
    } else if (typeof date === 'string') {
      dateObj = new Date(date);
    } else {
      return null;
    }
    
    // Use local date components to avoid timezone conversion
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  /**
   * Parse date string to Date object avoiding timezone issues
   * Handles ISO format (YYYY-MM-DD) and MM/DD/YYYY format
   */
  parseDate(dateString: string): Date | null {
    if (!dateString) return null;
    
    // Handle ISO format (YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss)
    const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      const year = parseInt(isoMatch[1]);
      const month = parseInt(isoMatch[2]) - 1; // Month is 0-indexed
      const day = parseInt(isoMatch[3]);
      return new Date(year, month, day);
    }
    
    // Fallback to MM/DD/YYYY format
    const parts = dateString.split('/');
    if (parts.length === 3) {
      return new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
    }
    
    return null;
  }
}
